import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'polaris-components-quickstart.tasks.prioritize-and-plan.title.non-final',
		defaultMessage: 'Prioritize and plan',
		description: 'The title appears on the list of onboarding tasks in the sidebar',
	},
	description: {
		id: 'polaris-components-quickstart.tasks.prioritize-and-plan.description.non-final',
		defaultMessage:
			'Use fields to develop your prioritization framework through team collaboration and flexible planning.',
		description:
			'The description appears on the expanded task item of onboarding quickstart sidebar below the title',
	},
	tip: {
		id: 'polaris-components-quickstart.tasks.prioritize-and-plan.tip.non-final',
		defaultMessage:
			'Tip: You can use impact, effort, or other numeric fields. Try pre-built views to check other methods.',
		description:
			'The tip appears on the expanded task item of onboarding quickstart sidebar below the description',
	},
});
